<template>
  <div>
    <b-row v-if="detailData">
      <b-col class="d-flex justify-content-end" cols="12" md="12">
        <b-button class="ml-1" style="height: 42px; margin-bottom: 12px" variant="primary" @click="exportPdf()">Xuất
          pdf
        </b-button>
      </b-col>
    </b-row>
    <div id="pdfContentContainer" style="font-family: 'Montserrat', sans-serif;">
      <b-row>
        <b-col class="mb-2 d-flex justify-content-center pyc-header" cols="12">
          {{ detailData && detailData.name }}
        </b-col>
      </b-row>
      <div v-if="detailInfo != null && detailInfo.pycChild.length > 0">
        <b-card v-for="(item, idx) in detailInfo.pycChild" class="col-12" no-body>
          <div class="m-2">
            <div style="font-size: 30px; font-weight: bold; margin-bottom: 20px">
              {{ item && item.name }}
            </div>
            <div
                v-for="(temp, index) in item.templates"
                v-if="item.templates.length > 0"
                :key="index"
            >
              <div class="title-id">Mẫu số {{ index + 1 }}</div>
              <detail
                  :ref="`editModelFormRef${idx}-${index}`"
                  :index="index"
                  :initData="item.listNotify[index]"
                  :isAddTemplateBtn="index == item.templates.length - 1"
                  :pycType="item && item.type ? item.type : ''"
              />
              <div v-if="index != item.templates.length - 1" class="break-line"></div>
            </div>
          </div>
        </b-card>
      </div>
      <b-card v-else class="col-12" no-body>
        <div
            style="
            height: 500px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 17px;
            font-weight: bold;
          "
        >
          No data
        </div>
      </b-card>
    </div>
    <b-row v-if="detailInfo != null && detailInfo.isApproved">
      <b-col class="text-align-right" cols="12">
        <b-button class="btn-icon p-inline-30 mr-2" variant="danger" @click="onAppove"
        >Duyệt
        </b-button
        >
        <b-button class="btn-icon p-inline-30" variant="danger" @click="onShowCancelModal"
        >Từ chối
        </b-button>
      </b-col>
    </b-row>
    <b-modal
        id="cancel-modal-add-reason"
        body-class="p-0"
        ok-variant="info"
        scrollable
        size="sm"
        title="Lý do từ chối"
        @cancel="reason = ''"
        @close="reason = ''"
        @ok="onCancel"
    >
      <div class="cancel-container">
        <input v-model="reason" type="text"/>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {BButton, BCard, BCol, BRow} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Detail from "../detail/detail.vue";
import {jsPDF} from "jspdf";
import {Montserrat} from "../../../../assets/strings/Montserrat"

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    Detail,
  },
  props: {
    pycType: {
      type: String,
      default: "",
    },
  },
  async mounted() {
    this.detaiId = this.$route.params.id;

    // if (!this.detaiId) {
    //   this.detaiId = 2;
    // }
    this.getDetailData(this.detaiId);
    this.getComments(this.detaiId);
    this.getInitDropdownData();
  },
  computed: {
    detailInfo() {
      return this.detailData;
    },
  },
  watch: {},
  methods: {
    exportPdf() {
      var doc = new jsPDF("p", 'pt', 'a4');

      doc.addFileToVFS("/fonts/Montserrat-Regular.ttf", Montserrat);
      doc.addFont("/fonts/Montserrat-Regular.ttf", "Montserrat", "normal");
      doc.setFont("Montserrat");

      var elementHTML = document.querySelector("#pdfContentContainer");
      const clientRect = document.querySelector("#pdfContentContainer").getBoundingClientRect()

      doc.html(elementHTML, {
        callback: function (doc) {
          // Save the PDF
          doc.save('Doc.pdf');
        },
        fontFaces: [
          {
            family: "Montserrat Thin"
          }
        ],
        margin: [60, 40],
        autoPaging: true,
        x: 0,
        y: 0,
        width: 522, //target width in the PDF document
        windowWidth: clientRect.width || 1000 //window width in CSS pixels
      });
    },
    async getComments(campId) {
      const data = {
        campId,
        page: 1,
        pageSize: 9999999,
      };
      const cmts = await useJwt.post("listComment", data);
      if (cmts.data && cmts.data.result) {
        this.comments = cmts.data.result;
      } else {
        this.comments = [];
      }
    },
    async getDetailData(id) {
      const response = await useJwt.get(`listPycChild/${id}`);
      if (response.data.code === 200) {
        let data = JSON.parse(JSON.stringify(response.data.result[0]));

        if (data && data.pycChild) {
          for (const idx in data.pycChild) {
            const res = await useJwt.get(`CampDetail/${data.pycChild[idx].id}`);

            if (res.data.code === 200) {
              data.pycChild[idx] = {
                ...data.pycChild[idx],
                ...JSON.parse(JSON.stringify(res.data.result)),
              };
              if (data.pycChild[idx] && data.pycChild[idx].listNotify != null) {
                data.pycChild[idx].templates = data.pycChild[idx].listNotify.map(
                    (i) => "a"
                );
              }
            }
          }
        }

        this.detailData = data;
      } else {
        this.detailData = null;
      }
    },
    async onSubmitComment(evt) {
      if (evt.keyCode == 13 && !evt.shiftKey && this.textCmt.trim().length > 0) {
        const data = {
          content: this.textCmt.trim(),
          requestId: this.detaiId,
        };
        const response = await useJwt.post(`comment`, data);
        if (response.data.code === 200) {
          this.getComments(this.detaiId);
          this.textCmt = "";
        }
      }
    },
    async onAppove() {
      var res = await this.$bvModal.msgBoxConfirm("Bạn có chắc chắn muốn duyệt", {
        title: "Duyệt",
        size: "sm",
      });

      if (res) {
        // const data = {
        //   id: this.detaiId,
        //   isAccept: true,
        //   reason: "",
        // };
        const response = await useJwt.get(`approPycGroup/${this.detaiId}`);
        if (response.data.code === 200) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Phiếu yêu cầu tổng hợp đã được duyệt thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
          setTimeout(() => {
            this.$router.push(`/general-noti-request`);
          }, 300);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
        }
      }
    },
    async onShowCancelModal() {
      this.$bvModal.show("cancel-modal-add-reason");
    },
    async onCancel() {
      const data = {
        id: this.detaiId,
        reason: this.reason,
      };
      this.reason = "";
      const response = await useJwt.post(`reject-pyc-group`, data);
      if (response.data.code === 200) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Từ chối thành công!",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: response.data.message,
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
      }
    },
    async getInitDropdownData() {
      const urgentData = await useJwt.get("isUrgent");
      if (urgentData.data && urgentData.data.result) {
        this.urgentSelectData = urgentData.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }

      const requestTypeData = await useJwt.get("requestType");
      if (requestTypeData.data && requestTypeData.data.result) {
        this.requestTypeSelectData = requestTypeData.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }

      const dropListData = await useJwt.get("dropListServices");
      if (dropListData.data && dropListData.data.result) {
        this.dropListSelectData = dropListData.data.result.map((item) => ({
          id: item.id,
          text: item.name,
        }));
      }
    },
  },
  data() {
    return {
      templates: [],
      detailData: null,
      detaiId: null,
      isExpandComment: false,
      comments: [],
      textCmt: "",
      reason: "",
      urgentSelectData: [],
      requestTypeSelectData: [],
      dropListSelectData: [],
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.modal-activated-order {
  height: 700px;
  color: #000000;
}

.col-700-scroll {
  height: 680px;
  overflow: auto;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.unselected {
  background: rgb(175, 175, 175) !important;
  border: rgb(175, 175, 175) !important;
}

.text-end {
  text-align: end;
}

.action-col {
  width: 100%;
  display: flex;
  justify-content: center;
}

.order-id:hover {
  cursor: pointer;
  font-weight: bold;
  color: rgb(34, 100, 243);
}

.detail-custom-table {
  width: 100%;
}

.detail-custom-table {
  display: inline-table;
  border: solid 1px rgb(207 207 207);
}

.detail-custom-table th,
.detail-custom-table td {
  border: solid 1px rgb(207 207 207);
  padding: 5px 10px;
}

.detail-custom-table th {
  vertical-align: baseline;
}

.history-call__header {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.history-call__header h5 {
  margin: 0;
}

.note-question {
  font-style: italic;
  color: rgb(233, 71, 22);
  margin-bottom: 9px;
}

.p-inline-30 {
  padding-inline: 30px !important;
}

.pyc-header {
  font-size: 25px;
  font-weight: bold;
}

.break-line {
  width: 100%;
  height: 1px;
  background: rgb(171, 171, 171);
  margin: 20px 0;
}

.title-id {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 20px;
}

.no-data {
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: rgba(69, 69, 69, 0.702);
}

.comment-container {
  border: 1px solid rgb(159, 158, 158);
  border-radius: 5px;
  width: 100%;
  margin-bottom: 10px;
}

.comment-collapsed {
  padding: 8px 15px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
}

.comment-expand {
  padding: 8px 15px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid rgb(190, 190, 190);
  font-size: 18px;
}

.comment-content__container {
  min-height: 250px;
  display: flex;
  flex-direction: column;
}

.detail-comment {
  height: 0;
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  overflow-y: scroll;
  padding: 0px 5px 5px 10px;
}

.detail-comment::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.detail-comment::-webkit-scrollbar-track {
  background: white;
}

/* Handle */
.detail-comment::-webkit-scrollbar-thumb {
  background: rgb(184, 184, 184);
  border-radius: 50px;
  cursor: pointer;
}

/* Handle on hover */
.detail-comment::-webkit-scrollbar-thumb:hover {
  background: rgb(131, 131, 131);
  border-radius: 50px;
  cursor: pointer;
}

.bottom-input-comment {
  border-top: 1px solid rgb(190, 190, 190);
  padding: 8px;
  width: 100%;
}

.bottom-input-comment > textarea {
  width: 100%;
  height: 40px;
  outline: none;
  padding: 3px 8px;
  border: 1px solid rgb(190, 190, 190);
  border-radius: 3px;
  resize: none;
}

.bottom-input-comment > textarea::placeholder {
  color: rgb(194, 193, 193);
}

.main-detail-comment {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  margin-bottom: 15px;
}

.name-info {
  display: flex;
  align-items: center;
}

.top-avt {
  height: 100%;
  display: flex;
  align-items: flex-start;
}

.avt-comment {
  width: 30px;
  height: 30px;
  margin-right: 5px;
  border-radius: 50%;
  border: 1px solid rgb(188, 188, 188);
  display: flex;
  justify-content: center;
  align-items: center;
}

.name-comment {
  font-weight: bold;
  flex-grow: 1;
  width: 0;
}

.text-comment {
  border-radius: 4px;
  border: 1px solid rgb(187, 186, 186);
  margin-top: 5px;
  padding: 5px 8px;
}

.camp-container {
  position: fixed;
  z-index: 2;
  top: 240px;
  right: 25px;
  width: 450px;
  background: white;
  padding: 15px 8px;
  border-radius: 15px;
  border: 1px solid rgb(187, 186, 186);
}

.cancel-container {
  width: 100%;
  padding: 20px;
}

.cancel-container > input {
  width: 100%;
  padding: 5px 10px;
  font-size: 15px;
  outline: none;
  border-radius: 4px;
  border: 1px solid #dfdfdf;
}
</style>
